import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
} from "@mui/material";

const CourseTable = ({
  currentItems,
  handleClickOpen,
  showMarkProcessed = false,
  onMarkProcessed,
}) => {
  const items = Array.isArray(currentItems) ? [...currentItems] : [];
  items.sort((a, b) => {
    const toTs = (c) => {
      const d = String(c?.date || "").slice(0, 10);
      const tRaw = c?.startTime || c?.start_time || "";
      const t = String(tRaw).trim();
      const hhmmss =
        t.length >= 8 ? t.slice(0, 8) : t.length >= 5 ? `${t.slice(0, 5)}:00` : "00:00:00";
      if (!d) return 0;
      const ts = Date.parse(`${d}T${hhmmss}`);
      return Number.isFinite(ts) ? ts : 0;
    };
    return toTs(b) - toTs(a);
  });

  return (
    <TableContainer>
    <Table sx={{ minWidth: 650 }}>
      <TableHead>
        <TableRow>
          <TableCell>Actions</TableCell>
          <TableCell>AD ID</TableCell>
          <TableCell>ICPIS Manager</TableCell>
          <TableCell>AD Address</TableCell>
          <TableCell>Time Zone</TableCell>
          <TableCell>Course Title</TableCell>
          <TableCell>Course Instructor</TableCell>
          <TableCell>Course Date</TableCell>
          <TableCell>Course Start Time</TableCell>
          <TableCell>Course End Time</TableCell>
          <TableCell>Course Price</TableCell>
          <TableCell>Course registrationLink</TableCell>
          <TableCell>AD Published</TableCell>
          <TableCell>Course Processed</TableCell>
          <TableCell>Added on Enrollware</TableCell>
          <TableCell>Course Status</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {items.length > 0 ? (
          items.map((course) => (
            <TableRow key={course.id}>
              <TableCell>
                {handleClickOpen && (
                  <Button
                    variant="outlined"
                    onClick={() => handleClickOpen(course)}
                  >
                    Edit
                  </Button>
                )}
                {showMarkProcessed && (
                  <Button
                    variant="text"
                    size="small"
                    sx={{ ml: 1 }}
                    onClick={() => onMarkProcessed && onMarkProcessed(course)}
                  >
                    Mark AD Published
                  </Button>
                )}
              </TableCell>
              <TableCell>{course.id}</TableCell>
              <TableCell>{course.icpisManager}</TableCell>
              <TableCell>{course.address}</TableCell>
              <TableCell>{course.timeZone}</TableCell>
              <TableCell>{course.courseTitle}</TableCell>
              <TableCell>{course.instructorId}</TableCell>
              <TableCell>{course.date}</TableCell>
              <TableCell>{course.startTime}</TableCell>
              <TableCell>{course.endTime}</TableCell>
              <TableCell>{course.price}</TableCell>
              <TableCell>{course.registrationLink}</TableCell>
              <TableCell>{String(course.active)}</TableCell>
              <TableCell>{String(course.processed)}</TableCell>
              <TableCell>{String(course.enrollwareAdded)}</TableCell>
              <TableCell>
                {course.courseStatus === 0 && "Normal"}
                {course.courseStatus === 1 && "Cancelled (Reusable)"}
                {course.courseStatus === 2 && "Already Reused"}
                {course.courseStatus === 3 && "Repost Required"}
              </TableCell>
            </TableRow>
          ))
        ) : (
          <TableRow>
            <TableCell colSpan={9} align="center">
              No data available
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  </TableContainer>
  );
};

export default CourseTable;
